import {
  Box,
  Button,
  Drawer,
  FormControl,
  FormHelperText,
  FormLabel,
  IconButton,
  MenuItem,
  Select,
  TextField,
  Typography
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import CheckIcon from '@material-ui/icons/Check';
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import { Autocomplete } from "@material-ui/lab";
import { Radio } from "antd";
import farmApi from "api/farmApi";
import utilApi from "api/utilApi";
import { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectListProvince, setListProvince } from "./filterSlice";

const useStyles = makeStyles((theme) => ({
  drawerPaper: {
    width: 330,
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    borderBottom: "1px solid #3D3D3D40",
    padding: "10px 0px",
  },
  arrowButton: {
    backgroundColor: "white",
    borderRadius: "50%",
  },
  content: {
    padding: "35px",
  },
  formControl: {
    marginBottom: 24,
    minWidth: "100%",
    "& .MuiSelect-outlined.MuiSelect-outlined": {
      padding: "12px",
      border: "1px solid #E5E5E5",
    },
    "& .MuiInputBase-input.Mui-disabled": {
      opacity: 0.6,
      background: "#fdf5f5",
    },
  },
  formLabel: {
    marginBottom: 8,
    color: "#08090D",
    fontWeight: 600,
    fontSize: 14,
  },
  buttonsContainer: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: theme.spacing(2),
    "& > button": {
      minWidth: 125,
      borderRadius: 8,
    },
  },
  button_delete: {
    border: "1px solid #F65C00",
    background: "transparent",
    color: "#08090D",
  },
  button_filter: {
    background: "#F65C00",
    color: "#fff",
    "&:hover": {
      background: "#F65C00",
    },
  },
  filterTitle: {
    fontSize: "20px",
    fontWeight: 600,
    color: "#08090D",
  },
  selectEmpty: {
    color: "#000",
  },
  labelAutoComplete:{
    background:'#F4F4F4',
    padding:'6px 8px',
    color :'#000',
    marginRight: 6,
    borderRadius: '2px'
  },
  optionAutocomplete :{
    display:'flex',
    alignItems:'center',
    justifyContent:'space-between',
    width:'100%',
    "&> h4":{
      fontSize:16,
      color:'#08090D',
    },
    "& > svg":{
      width: 20,
      height:20,
      color:'#F65C00'
    }
  }
}));

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const regions = [
  {
    name: "Bắc",
    value: "1",
  },
  {
    name: "Trung",
    value: "2",
  },
  {
    name: "Nam",
    value: "3",
  },
];

const listValueFormOfTestTraditional = [
  {
    name: "Vị trí - cấu trúc",
    value: "VTCT",
  },
  {
    name: "Thực hành chăn nuôi tốt",
    value: "THCN",
  },
  {
    name: "Quản lý",
    value: "QL",
  },
  {
    name: "Vector vận chuyển",
    value: "VTVC",
  },
  {
    name: "Vector vật dụng",
    value: "VTVD",
  },
  {
    name: "Vector động vật",
    value: "VTDV",
  },
  {
    name: "Vector thức ăn nước uống",
    value: "VTTA",
  },
  {
    name: "Vector con người",
    value: "VTCN",
  },
];
const listValueFormOfTestModern = [
  {
    name: "Bên trong",
    value: "BT",
  },
  {
    name: "Bên ngoài",
    value: "BN",
  },
];
const DrawerFilter = ({
  open,
  onClose,
  onSubmit,
  filter,
  filterDetail = false,
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [disabledFormOfTest, setDisabledFormOfTest] = useState(true);
  const [errorProvince, setErrorProvince] = useState(false);

  const [selectedRegion, setSelectedRegion] = useState(filter?.region || "");
  const [listFarm ,setListFarm] = useState([]);
  const [farmSelected, setFarmSelected] = useState([]);
  const [listFormOfTest, setListFormOfTest] = useState([]);
  const [selectedValFormOfTest, setSelectedValFormOfTest] = useState(
    filter?.hinhThucKiemTra || ""
  );
  const [selectedValFormOfAccess, setSelectedValFormOfAccess] = useState(
    filter?.hinhThucTiepCan
  );
  const [selectedProvince, setSelectedProvince] = useState(
    filter?.province || ""
  );
  const listProvince = useSelector(selectListProvince);

  useEffect(() => {
    if (filter?.region) {
      handleGetListProvince(filter?.region);
    }
    if(filter?.province){
      getFilterFarms(filter?.province)
    }
    
  }, [filter.province, filter.farmIds, filter.region]);
  useEffect(() => {
    if (selectedValFormOfAccess) {
      setDisabledFormOfTest(false);
    }
    if (selectedValFormOfAccess === "TT" || filter?.hinhThucTiepCan === "TT") {
      setListFormOfTest(listValueFormOfTestTraditional);
    } else if (
      selectedValFormOfAccess === "HD" ||
      filter?.hinhThucTiepCan === "HD"
    ) {
      setListFormOfTest(listValueFormOfTestModern);
    }
  }, [selectedValFormOfAccess]);

  const handleRegionChange = async (event) => {
    const valueRegion = event.target.value;
    setSelectedRegion(valueRegion);
    setSelectedProvince(""); // Reset province when region changes
    setListFarm([]);
    await handleGetListProvince(valueRegion);
  };

  const handleChangeFormOfTest = async (event) => {
    const value = event.target.value;
    setSelectedValFormOfTest(value);
  };

  const handleGetListProvince = async (id) => {
    try {
      const res = await utilApi.getListProvince(id);
      dispatch(setListProvince(res.provinces));
    } catch (error) {}
  };

  const handleProvinceChange = async (event) => {
    setSelectedProvince(event.target.value);
    setErrorProvince(false);
    if(filterDetail){
      getFilterFarms(event.target.value)
    }
  };
  const getFilterFarms = async(provinceId)=>{
    try {
      const data = await farmApi.getFilterFarms({
        province: provinceId
      });
      setListFarm(data.farms);
      if(filter?.farmIds){
        const defaultVal = data.farms.filter(farm => filter?.farmIds?.includes(farm.id))
        setFarmSelected(defaultVal);
      }
      
    } catch (error) {
      
    }
  }

  const onReset = () => {
    setSelectedRegion("");
    setSelectedProvince("");
    setSelectedValFormOfTest("");
    setSelectedValFormOfAccess("");
    setFarmSelected([]);
    setListFarm([]);

    dispatch(setListProvince([]));
  };

  const onChaneFormOfAccess = (e) => {
    setSelectedValFormOfAccess(e.target.value);
  };

  const onChangeFarm = (e, value) => {
    setFarmSelected(value);
  };

  const onFilter = () =>{
    if(selectedRegion && !selectedProvince ){ // check filter region and dont filter province
      setErrorProvince(true);
      return;
    }
    onSubmit({
      region: selectedRegion || null,
      province: selectedProvince || null,
      hinhThucKiemTra: selectedValFormOfTest || null ,
      hinhThucTiepCan: selectedValFormOfAccess || null,
      farmIds: farmSelected.length > 0 ?  farmSelected?.map(x=>x.id) : null
    })
  }
  return (
    <Drawer anchor="right" open={open} onClose={onClose}>
      <Box className={classes.drawerPaper}>
        <Box className={classes.header}>
          <IconButton className={classes.arrowButton} onClick={onClose}>
            <ChevronRightIcon />
          </IconButton>
          <Typography variant="subtitle1" className={classes.filterTitle}>
            Bộ lọc
          </Typography>
          <Box></Box>
        </Box>
        <Box className={classes.content}>
          <FormControl variant="outlined" className={classes.formControl}>
            <FormLabel className={classes.formLabel}>Khu vực:</FormLabel>
            <Select
              value={selectedRegion}
              onChange={handleRegionChange}
              classes={{ select: classes.selectEmpty }}
            >
              {regions.map((region) => (
                <MenuItem key={region.name} value={region.value}>
                  {region.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl
            variant="outlined"
            className={classes.formControl}
            disabled={!selectedRegion}
            error={errorProvince}
          >
            <FormLabel className={classes.formLabel}>Tỉnh:</FormLabel>
            <Select
              value={selectedProvince}
              onChange={handleProvinceChange}
              classes={{ select: classes.selectEmpty }}
            >
              {listProvince.length > 0 &&
                listProvince.map((province) => (
                  <MenuItem key={province} value={province}>
                    {province}
                  </MenuItem>
                ))}
            </Select>
            { errorProvince && <FormHelperText style={{ margin: 0}}>Vui lòng chọn Tỉnh</FormHelperText> }
          </FormControl>
          {filterDetail && (
            <Fragment>
              <FormControl className={classes.formControl}>
                <FormLabel className={classes.formLabel} style={{ color : listFarm.length === 0 && 'rgba(0, 0, 0, 0.38)'}}>Tên trại:</FormLabel>
                <Autocomplete
                  multiple
                  options={listFarm}
                  disabled={listFarm.length === 0}
                  disableCloseOnSelect
                  getOptionLabel={(option) => option.name}
                  value={farmSelected}
                  onChange={onChangeFarm}
                  renderOption={(option) => (
                   <div className={classes.optionAutocomplete}>
                    <h4>{option.name}</h4>
                    {farmSelected.some(x=> x.id === option.id)  && <CheckIcon />}
                   </div>
                  )}
                  renderInput={(params) => (
                    <TextField
                    disabled={listFarm.length === 0}
                      {...params}
                      variant="outlined"
                    />
                  )}
                  renderTags={(value, getTagProps) =>
                    value.map((option, index) => (
                      <div className={classes.labelAutoComplete}>{option.name}</div>
                    ))
                  }
                />
              </FormControl>
              <FormControl variant="outlined" className={classes.formControl}>
                <FormLabel className={classes.formLabel}>
                  Hình thức tiếp cận:
                </FormLabel>
                <Box mt={1}>
                  <Radio.Group
                    onChange={onChaneFormOfAccess}
                    value={selectedValFormOfAccess}
                  >
                    <Radio value={"TT"}>Truyền thống</Radio>
                    <Radio value={"HD"}>Hiện đại</Radio>
                  </Radio.Group>
                </Box>
              </FormControl>
              <FormControl variant="outlined" className={classes.formControl}>
                <FormLabel className={classes.formLabel} style={{ color : disabledFormOfTest && 'rgba(0, 0, 0, 0.38)'}}>
                  Hình thức kiểm tra:
                </FormLabel>
                <Select
                  disabled={disabledFormOfTest}
                  value={selectedValFormOfTest}
                  onChange={handleChangeFormOfTest}
                  classes={{ select: classes.selectEmpty }}
                  style={{ marginTop: 8 }}
                >
                  {listFormOfTest.map((region) => (
                    <MenuItem key={region.name} value={region.value}>
                      {region.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Fragment>
          )}
          <Box className={classes.buttonsContainer}>
            <Button
              className={classes.button_delete}
              variant="outlined"
              color="primary"
              onClick={onReset}
            >
              Xóa tất cả
            </Button>
            <Button
              className={classes.button_filter}
              variant="contained"
              color="primary"
              onClick={onFilter}
            >
              Tìm kiếm
            </Button>
          </Box>
        </Box>
      </Box>
    </Drawer>
  );
};

export default DrawerFilter;
